import { render } from "./WorkspaceUnlicensedProduct.vue?vue&type=template&id=6b116142&scoped=true&ts=true"
import script from "./WorkspaceUnlicensedProduct.vue?vue&type=script&lang=ts"
export * from "./WorkspaceUnlicensedProduct.vue?vue&type=script&lang=ts"

import "./WorkspaceUnlicensedProduct.vue?vue&type=style&index=0&id=6b116142&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b116142"]])

export default __exports__